(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsStandardHeaderActions', rmsStandardHeaderActions);

    function rmsStandardHeaderActions() {
        return {
            restrict: 'E',
            scope: {
                form: '='
            },
            controller: rmsStandardHeaderActionsCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/app/components/standard-header-actions'
        };
    }

    function rmsStandardHeaderActionsCtrl(lodash, $timeout, $scope) {
        var vm = this;
        this.$onInit = function() {
            vm.loading = false;
            vm.hasForm = hasForm;

            $scope.$watch(function() {
                return vm.form;
            }, function() {
                vm.loading = true;
                $timeout(function() {
                    vm.loading = false;
                }, 100);
            });
        }

        function hasForm() {
            return !lodash.isEmpty(vm.form) && !vm.loading;
        }
    }
})();